import { isNotNil, omit } from 'es-toolkit';
/**
 * Flatten an deep object into one
 * @param obj
 */
export const flattenObj = (object) => {
    const keys = Object.keys(object);
    return keys.reduce((result, key) => {
        if (typeof object[key] === 'object' && isNotNil(object[key])) {
            const flattenedObj = flattenObj(object[key]);
            const mappedObj = Object.keys(flattenedObj).reduce((result, flattenedObjKey) => {
                return {
                    ...result,
                    [`${key}.${flattenedObjKey}`]: flattenedObj[flattenedObjKey],
                };
            }, {});
            return { ...result, ...mappedObj };
        }
        return { ...result, [key]: object[key] };
    }, {});
};
export const omitTypenameFromObj = (obj) => omit(obj, ['__typename']);
export const omitTypenameAndIdFromObj = (obj) => (obj ? omit(obj, ['__typename', 'id']) : obj);
export const objectEntries = (obj) => {
    return Object.entries(obj);
};
/** Map a list of `{ id }` objects down to their ids. */
export const toIds = (items) => items.map(({ id }) => id);
/** Build a Prisma relation `set` operation from a list of `{ id }` objects. */
export const toSet = (items) => ({
    set: items.map(({ id }) => ({ id })),
});
export const hasKey = (obj, key) => {
    return key in obj;
};
export const getEntry = (obj, key) => {
    if (hasKey(obj, key)) {
        return obj[key];
    }
    return undefined;
};
//# sourceMappingURL=object.js.map